<aside
    class="flex h-full flex-col
           border-r border-white/[0.055]
           bg-[#181412]
           text-white"
>

    <!-- ====================================================== -->
    <!-- BRAND -->
    <!-- ====================================================== -->

    <div
        class="flex h-[76px]
               shrink-0 items-center
               px-5"
    >

        <div
            class="flex h-11 w-11
                   items-center justify-center
                   rounded-2xl
                   bg-gradient-to-br
                   from-[#ef6b49]
                   to-[#c9442e]
                   text-lg font-bold
                   text-white
                   shadow-[0_10px_28px_rgba(217,82,53,0.24)]"
        >
            R
        </div>


        <div
            class="ml-3 min-w-0"
        >

            <div
                class="text-[17px]
                       font-bold
                       tracking-tight
                       text-white"
            >
                Restaurant<span
                    class="text-[#ff8664]"
                >OS</span>
            </div>


            <div
                class="mt-0.5
                       truncate
                       text-[9px]
                       font-medium
                       tracking-[0.08em]
                       text-[#756761]"
            >
                Gestiona. Crece. Conecta.
            </div>

        </div>

    </div>


    <!-- ====================================================== -->
    <!-- RESTAURANT + BRANCH CONTEXT -->
    <!-- ====================================================== -->

    <div
        class="shrink-0
               px-3 pb-3"
    >

        <!-- ================================================== -->
        <!-- RESTAURANT -->
        <!-- ================================================== -->

        <div class="relative">

            <button
                type="button"
                class="group
                       flex w-full
                       items-center gap-3
                       rounded-2xl
                       border border-white/[0.07]
                       bg-white/[0.045]
                       px-3 py-3.5
                       text-left
                       shadow-[0_6px_20px_rgba(0,0,0,0.06)]
                       transition-all duration-200
                       hover:border-[#ff8664]/20
                       hover:bg-white/[0.065]"
                (click)="toggleRestaurantMenu()"
            >

                <!-- ICON -->

                <div
                    class="flex h-10 w-10
                           shrink-0
                           items-center
                           justify-center
                           rounded-xl
                           bg-[#d95235]/12
                           text-[#ff8664]
                           transition
                           group-hover:bg-[#d95235]/18"
                >

                    <nz-icon
                        nzType="shop"
                        nzTheme="outline"
                    ></nz-icon>

                </div>


                <!-- INFO -->

                <div
                    class="min-w-0 flex-1"
                >

                    <div
                        class="mb-0.5
                               text-[9px]
                               font-semibold
                               uppercase
                               tracking-[0.14em]
                               text-[#756761]"
                    >
                        Restaurante
                    </div>


                    <div
                        class="truncate
                               text-sm
                               font-semibold
                               text-[#f5efec]"
                    >
                        {{ restaurantName() }}
                    </div>


                    @if (restaurantStatus()) {

                        <div
                            class="mt-1
                                   flex items-center
                                   gap-1.5
                                   text-[10px]
                                   text-[#8f7f78]"
                        >

                            <span
                                class="h-1.5 w-1.5
                                       rounded-full
                                       bg-emerald-400"
                            ></span>

                            {{ restaurantStatus() }}

                        </div>

                    }

                </div>


                <!-- ARROW -->

                @if (restaurantsLoading()) {

                    <nz-icon
                        nzType="loading"
                        nzTheme="outline"
                        class="shrink-0
                               text-[#756761]"
                    ></nz-icon>

                } @else {

                    <nz-icon
                        nzType="down"
                        nzTheme="outline"
                        class="shrink-0
                               text-[10px]
                               text-[#756761]
                               transition-transform
                               duration-200"
                        [class.rotate-180]="restaurantMenuOpen()"
                    ></nz-icon>

                }

            </button>


            <!-- ============================================== -->
            <!-- RESTAURANT DROPDOWN -->
            <!-- ============================================== -->

            @if (restaurantMenuOpen()) {

                <div
                    class="absolute
                           left-0 right-0
                           top-[calc(100%+7px)]
                           z-[60]
                           overflow-hidden
                           rounded-2xl
                           border border-white/[0.08]
                           bg-[#211a17]
                           shadow-[0_20px_50px_rgba(0,0,0,0.38)]"
                >

                    <div
                        class="border-b
                               border-white/[0.06]
                               px-3 py-2.5"
                    >

                        <div
                            class="text-[10px]
                                   font-semibold
                                   uppercase
                                   tracking-[0.14em]
                                   text-[#756761]"
                        >
                            Mis restaurantes
                        </div>

                    </div>


                    <div
                        class="max-h-60
                               overflow-y-auto
                               p-1.5"
                    >

                        @for (
                            restaurant of restaurants();
                            track restaurant.id
                        ) {

                            <button
                                type="button"
                                class="group
                                       flex w-full
                                       items-center
                                       gap-3
                                       rounded-xl
                                       px-2.5 py-2.5
                                       text-left
                                       transition
                                       hover:bg-white/[0.055]"
                                (click)="selectRestaurant(restaurant)"
                            >

                                <div
                                    class="flex h-8 w-8
                                           shrink-0
                                           items-center
                                           justify-center
                                           rounded-lg
                                           bg-[#d95235]/10
                                           text-xs
                                           font-bold
                                           text-[#ff9576]"
                                >
                                    {{
                                        restaurant.name
                                            .substring(0, 1)
                                            .toUpperCase()
                                    }}
                                </div>


                                <div
                                    class="min-w-0 flex-1"
                                >

                                    <div
                                        class="truncate
                                               text-xs
                                               font-semibold
                                               text-[#eee6e2]"
                                    >
                                        {{ restaurant.name }}
                                    </div>


                                    <div
                                        class="mt-0.5
                                               flex items-center
                                               gap-1.5
                                               text-[10px]
                                               text-[#756761]"
                                    >

                                        <span
                                            class="h-1.5 w-1.5
                                                   rounded-full"
                                            [class.bg-emerald-400]="restaurant.status === 'ACTIVE'"
                                            [class.bg-blue-400]="restaurant.status === 'TRIAL'"
                                            [class.bg-amber-400]="restaurant.status === 'PENDING'"
                                            [class.bg-red-400]="restaurant.status === 'SUSPENDED'"
                                            [class.bg-slate-500]="restaurant.status === 'CLOSED'"
                                        ></span>

                                        {{ restaurant.status }}

                                    </div>

                                </div>


                                @if (
                                    selectedRestaurant()?.id ===
                                    restaurant.id
                                ) {

                                    <nz-icon
                                        nzType="check"
                                        nzTheme="outline"
                                        class="shrink-0
                                               text-[#ff8664]"
                                    ></nz-icon>

                                }

                            </button>

                        } @empty {

                            <div
                                class="px-3 py-5
                                       text-center
                                       text-xs
                                       text-[#756761]"
                            >
                                No tienes restaurantes disponibles.
                            </div>

                        }

                    </div>

                </div>

            }

        </div>


        <!-- ================================================== -->
        <!-- BRANCH -->
        <!-- ================================================== -->

        <div
            class="relative mt-2"
        >

            <button
                type="button"
                class="group
                       flex w-full
                       items-center gap-3
                       rounded-xl
                       border border-white/[0.055]
                       bg-black/10
                       px-3 py-2.5
                       text-left
                       transition-all
                       duration-200
                       hover:border-white/[0.09]
                       hover:bg-white/[0.035]
                       disabled:cursor-not-allowed
                       disabled:opacity-50"
                [disabled]="!selectedRestaurant()"
                (click)="toggleBranchMenu()"
            >

                <div
                    class="flex h-8 w-8
                           shrink-0
                           items-center
                           justify-center
                           rounded-lg
                           bg-white/[0.04]
                           text-[#9c8b83]
                           transition
                           group-hover:text-[#ff8664]"
                >

                    <nz-icon
                        nzType="environment"
                        nzTheme="outline"
                    ></nz-icon>

                </div>


                <div
                    class="min-w-0 flex-1"
                >

                    <div
                        class="mb-0.5
                               text-[9px]
                               font-semibold
                               uppercase
                               tracking-[0.12em]
                               text-[#665852]"
                    >
                        Sucursal
                    </div>


                    <div
                        class="truncate
                               text-xs
                               font-medium
                               text-[#cbbdb7]"
                    >
                        {{ branchName() }}
                    </div>

                </div>


                @if (branchesLoading()) {

                    <nz-icon
                        nzType="loading"
                        nzTheme="outline"
                        class="shrink-0
                               text-[#756761]"
                    ></nz-icon>

                } @else {

                    <nz-icon
                        nzType="down"
                        nzTheme="outline"
                        class="shrink-0
                               text-[9px]
                               text-[#665852]
                               transition-transform
                               duration-200"
                        [class.rotate-180]="branchMenuOpen()"
                    ></nz-icon>

                }

            </button>


            <!-- ============================================== -->
            <!-- BRANCH DROPDOWN -->
            <!-- ============================================== -->

            @if (branchMenuOpen()) {

                <div
                    class="absolute
                           left-0 right-0
                           top-[calc(100%+7px)]
                           z-[60]
                           overflow-hidden
                           rounded-2xl
                           border border-white/[0.08]
                           bg-[#211a17]
                           shadow-[0_20px_50px_rgba(0,0,0,0.38)]"
                >

                    <div
                        class="border-b
                               border-white/[0.06]
                               px-3 py-2.5"
                    >

                        <div
                            class="text-[10px]
                                   font-semibold
                                   uppercase
                                   tracking-[0.14em]
                                   text-[#756761]"
                        >
                            Sucursales
                        </div>

                    </div>


                    <div
                        class="max-h-56
                               overflow-y-auto
                               p-1.5"
                    >

                        @for (
                            branch of branches();
                            track branch.id
                        ) {

                            <button
                                type="button"
                                class="group
                                       flex w-full
                                       items-center
                                       gap-3
                                       rounded-xl
                                       px-2.5 py-2.5
                                       text-left
                                       transition
                                       hover:bg-white/[0.055]"
                                (click)="selectBranch(branch)"
                            >

                                <div
                                    class="flex h-8 w-8
                                           shrink-0
                                           items-center
                                           justify-center
                                           rounded-lg
                                           bg-white/[0.04]
                                           text-[#8c7b74]
                                           group-hover:text-[#ff8664]"
                                >

                                    <nz-icon
                                        nzType="environment"
                                        nzTheme="outline"
                                    ></nz-icon>

                                </div>


                                <div
                                    class="min-w-0 flex-1"
                                >

                                    <div
                                        class="truncate
                                               text-xs
                                               font-semibold
                                               text-[#eee6e2]"
                                    >
                                        {{ branch.name }}
                                    </div>


                                    <div
                                        class="mt-0.5
                                               truncate
                                               text-[10px]
                                               text-[#756761]"
                                    >

                                        {{ branch.code }}

                                        @if (branch.district) {

                                            <span>
                                                · {{ branch.district }}
                                            </span>

                                        }

                                    </div>

                                </div>


                                @if (
                                    branch.status === 'INACTIVE'
                                ) {

                                    <span
                                        class="rounded-full
                                               bg-red-500/10
                                               px-2 py-0.5
                                               text-[9px]
                                               font-semibold
                                               text-red-400"
                                    >
                                        Inactiva
                                    </span>

                                }


                                @if (
                                    selectedBranch()?.id ===
                                    branch.id
                                ) {

                                    <nz-icon
                                        nzType="check"
                                        nzTheme="outline"
                                        class="shrink-0
                                               text-[#ff8664]"
                                    ></nz-icon>

                                }

                            </button>

                        } @empty {

                            <div
                                class="px-3 py-5
                                       text-center
                                       text-xs
                                       text-[#756761]"
                            >
                                Este restaurante no tiene
                                sucursales disponibles.
                            </div>

                        }

                    </div>

                </div>

            }

        </div>

    </div>


    <!-- ====================================================== -->
    <!-- NAVIGATION -->
    <!-- ====================================================== -->

    <nav
        class="flex-1
               overflow-y-auto
               px-3 pb-5"
    >

        @for (
            item of menuItems;
            track item.label
        ) {

            @if (item.section) {

                <div
                    class="mb-2 mt-5
                           px-3
                           text-[9px]
                           font-semibold
                           tracking-[0.18em]
                           text-[#5f514b]
                           first:mt-2"
                >
                    {{ item.label }}
                </div>

            } @else {

                <a
    [routerLink]="item.route"
    routerLinkActive="active"
    class="sidebar-link
           group relative
           mb-1 flex items-center
           gap-3 rounded-xl
           px-3 py-[11px]
           text-[13px]
           font-medium
           transition-all
           duration-200"
>

    <!-- INDICADOR ACTIVO -->

    <span
        class="sidebar-active-line
               absolute left-0
               h-5 w-[3px]
               rounded-r-full
               bg-[#ff8664]"
    ></span>


    <!-- ICONO -->

    <nz-icon
        [nzType]="item.icon"
        nzTheme="outline"
        class="text-[16px]"
    ></nz-icon>


    <!-- TEXTO -->

    <span>
        {{ item.label }}
    </span>

</a>

            }

        }

    </nav>


    <!-- ====================================================== -->
    <!-- USER -->
    <!-- ====================================================== -->

    <div
        class="shrink-0
               border-t border-white/[0.055]
               bg-black/[0.06]
               p-3"
    >

        <button
            type="button"
            class="flex w-full
                   items-center gap-3
                   rounded-xl
                   px-2 py-2.5
                   text-left
                   transition
                   hover:bg-white/[0.04]"
        >

            <div
                class="flex h-10 w-10
                       shrink-0
                       items-center
                       justify-center
                       rounded-full
                       border border-white/[0.06]
                       bg-[#2b211d]
                       text-xs
                       font-bold
                       text-[#f0e6e1]"
            >
                {{ initials() }}
            </div>


            <div
                class="min-w-0 flex-1"
            >

                <div
                    class="truncate
                           text-sm
                           font-semibold
                           text-[#eee6e2]"
                >
                    {{ displayName() }}
                </div>


                <div
                    class="mt-0.5
                           truncate
                           text-[10px]
                           text-[#756761]"
                >
                    {{ primaryRole() }}
                </div>

            </div>


            <nz-icon
                nzType="more"
                nzTheme="outline"
                class="shrink-0
                       text-[#665852]"
            ></nz-icon>

        </button>

    </div>

</aside>